import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthenticationService } from 'app/core/authentication/authentication.service';

@Injectable()
export class ModalRecuperarSenhaService {

  constructor(private authenticationService: AuthenticationService) { }

  iniciarRecuperacaoDeSenha(cpf, email,contexto, tipoRecSenha, siglaSistema): Observable<any> {
    return this.authenticationService.resetPassword(cpf, email,contexto, tipoRecSenha, siglaSistema);
  }

}
